// extracted by mini-css-extract-plugin
module.exports = {"container":"_d1f768c0","result":"_2d795fee","searchResultIcon":"_b582dc8b"};